<template>
  <div class="card-title">
    <div class="inner">
      <span class="left">{{ titleLeft }}</span>
      <span class="right">{{ titleRight }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'page-title',
  data: function () {
    return {}
  },
  props: {
    titleLeft: {
      type: String,
      default: ''
    },
    titleRight: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.card-title {
  width: 100%;
  height: 59px;
  margin: 0 auto;
  line-height: 59px;
  font-size: 18px;
  font-weight: 500;
  color: #212121;
  // position: sticky;
  top: 0;
  background-color: #f1f1f1;
  z-index: 1;
  .inner {
    width: 1000px;
    margin: 0 auto;
  }
  .right {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/PageTitle.vue